// extracted by mini-css-extract-plugin
export default {"container":"registrationSubscribedService_container__xOT-G","data":"registrationSubscribedService_data__uD33q"};